import { ChartType, type TChartType } from '@dbl/core/chart';

/** 图表切换支持的 3 种类型 */
export const CHART_SWITCH_OPTIONS: TChartType[] = [
  ChartType.Table,
  ChartType.Line,
  ChartType.Bar,
];

/** 图表切换选项展示顺序：表格、折线图、柱状图 */
export const CHART_SWITCH_DISPLAY_ORDER: TChartType[] = [
  ChartType.Table,
  ChartType.Line,
  ChartType.Bar,
];

export const CHART_TYPE_LABEL_IDS: Partial<Record<TChartType, string>> = {
  [ChartType.Table]: 'dbl_chart_table',
  [ChartType.Line]: 'dbl_chart_line',
  [ChartType.Bar]: 'dbl_chart_bar',
};

export const CHART_TYPE_ICON: Partial<Record<TChartType, string>> = {
  [ChartType.Table]: 'sheet',
  [ChartType.Line]: 'discount-chart',
  [ChartType.Bar]: 'column-chart',
};

